import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import VideoLoader from './components/VideoLoader';
import LanguageModal from './components/LanguageModal';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import ProductDetail from './pages/ProductDetail';
import FAQ from './pages/FAQ';
import { Login as AdminLogin, Dashboard as AdminDashboard } from './admin/Admin';
import './App.css';

// A wrapper to hide Navbar/Footer on Admin routes
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navbar />}
      <main style={{ minHeight: '80vh' }}>
        {children}
      </main>
      {!isAdminRoute && <WhatsAppButton />}
      {!isAdminRoute && <Footer />}
    </div>
  );
};

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Immediately check window.location.pathname so initial load of /admin never triggers video or modal
  const isInitialAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  
  const [showVideoLoader, setShowVideoLoader] = useState(!isInitialAdmin);
  const [showLangModal, setShowLangModal] = useState(false);

  useEffect(() => {
    if (isAdminRoute) {
      setShowVideoLoader(false);
      setShowLangModal(false);
    }
  }, [isAdminRoute]);

  return (
    <>
      {!isAdminRoute && showVideoLoader && (
        <VideoLoader
          onComplete={() => {
            setShowVideoLoader(false);
            setShowLangModal(true);
          }}
        />
      )}
      {!isAdminRoute && showLangModal && (
        <LanguageModal onClose={() => setShowLangModal(false)} />
      )}
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogPost />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/faq" element={<FAQ />} />
          
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </Layout>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
